import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { version } from "../package.json";
export default function request(_x, _x2, _x3, _x4) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engineKey, method, path, params) {
    var headers, response, json, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = new Headers({
              "Content-Type": "application/json",
              "x-swiftype-integration": "search-ui",
              "x-swiftype-integration-version": version
            });
            _context.next = 3;
            return fetch("https://search-api.swiftype.com/api/v1/public/".concat(path), {
              method: method,
              headers: headers,
              body: JSON.stringify(_objectSpread({
                engine_key: engineKey
              }, params)),
              credentials: "include"
            });

          case 3:
            response = _context.sent;
            _context.prev = 4;
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);

          case 12:
            if (!(response.status >= 200 && response.status < 300)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", json);

          case 16:
            message = json && json.error ? json.error : response.status;
            throw new Error(message);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _request.apply(this, arguments);
}